import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf, Sparkles, Award, Heart } from 'lucide-react';
import { aboutContent } from '../data/mockData';

const ExcellenceNaturelle = () => {
  const { naturalProducts, commitments } = aboutContent;

  return (
    <div>
      {/* Hero Section */}
      <section 
        className="section-padding" 
        style={{ 
          background: 'linear-gradient(135deg, #F5F1E8 0%, #FDFCF9 100%)',
          textAlign: 'center' 
        }}
      >
        <div className="container" style={{ maxWidth: '900px' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
            <Leaf size={32} color="#C9A961" />
            <Sparkles size={24} color="#C9A961" />
          </div>
          <h1 className="hero-large" style={{ marginBottom: '24px' }}>
            Excellence Naturelle
          </h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
            {naturalProducts.description}
          </p>
        </div>
      </section>

      {/* Soins du Visage */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div className="grid-two-column" style={{ alignItems: 'center', gap: '64px' }}>
            <div>
              <img 
                src="https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/d4u4ioul_9DDC9875-A45A-4210-BB79-003216C6BDDB.png"
                alt="Soins du visage naturels"
                style={{ 
                  width: '100%', 
                  height: '500px', 
                  objectFit: 'cover',
                  border: '1px solid var(--border-light)'
                }}
              />
            </div>
            
            <div>
              <div style={{ 
                display: 'inline-flex', 
                alignItems: 'center', 
                gap: '8px', 
                padding: '8px 16px',
                background: 'var(--bg-secondary)',
                marginBottom: '20px'
              }}>
                <Sparkles size={16} color="#C9A961" />
                <span className="body-small" style={{ color: '#C9A961', fontWeight: 700 }}>
                  SOINS DU VISAGE
                </span>
              </div>
              
              <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
                99% d'ingrédients d'origine naturelle
              </h2>
              
              <p className="body-large" style={{ color: 'var(--text-secondary)', lineHeight: '1.8', marginBottom: '32px' }}>
                {naturalProducts.facialCare}
              </p>

              <div style={{ 
                padding: '24px',
                background: 'var(--bg-secondary)',
                borderLeft: '4px solid #C9A961'
              }}>
                <p className="body-regular" style={{ fontStyle: 'italic', color: 'var(--text-primary)' }}>
                  "Notre signature réside dans cette alliance parfaite entre efficacité scientifique et pureté botanique, pour révéler l'éclat naturel de votre peau."
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bronzage Sun Cosmetics */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div className="grid-two-column" style={{ alignItems: 'center', gap: '64px' }}>
            <div>
              <div style={{ 
                display: 'inline-flex', 
                alignItems: 'center', 
                gap: '8px', 
                padding: '8px 16px',
                background: 'var(--bg-primary)',
                marginBottom: '20px'
              }}>
                <Sparkles size={16} color="#C9A961" />
                <span className="body-small" style={{ color: '#C9A961', fontWeight: 700 }}>
                  SUN COSMETICS
                </span>
              </div>
              
              <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
                Bronzag'Expert 4ème génération
              </h2>
              
              <p className="body-large" style={{ color: 'var(--text-secondary)', lineHeight: '1.8', marginBottom: '32px' }}>
                {naturalProducts.tanning}
              </p>

              <div style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '16px'
              }}>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                  <div style={{ 
                    width: '40px', 
                    height: '40px', 
                    borderRadius: '50%',
                    background: '#C9A961',
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <span style={{ color: 'var(--bg-primary)', fontSize: '18px' }}>✓</span>
                  </div>
                  <div>
                    <h4 className="heading-3" style={{ marginBottom: '4px' }}>100% naturel</h4>
                    <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                      Formules d'origine végétale
                    </p>
                  </div>
                </div>

                <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                  <div style={{ 
                    width: '40px', 
                    height: '40px', 
                    borderRadius: '50%',
                    background: '#C9A961',
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <span style={{ color: 'var(--bg-primary)', fontSize: '18px' }}>✓</span>
                  </div>
                  <div>
                    <h4 className="heading-3" style={{ marginBottom: '4px' }}>Fabriqué en France</h4>
                    <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                      Qualité et traçabilité garanties
                    </p>
                  </div>
                </div>

                <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                  <div style={{ 
                    width: '40px', 
                    height: '40px', 
                    borderRadius: '50%',
                    background: '#C9A961',
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <span style={{ color: 'var(--bg-primary)', fontSize: '18px' }}>✓</span>
                  </div>
                  <div>
                    <h4 className="heading-3" style={{ marginBottom: '4px' }}>Technologie 4ème génération</h4>
                    <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                      Résultat uniforme et longue durée
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <img 
                src="https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/m9m1mvno_IMG_8486.png"
                alt="Sun Cosmetics bronzage"
                style={{ 
                  width: '100%', 
                  height: '500px', 
                  objectFit: 'cover',
                  border: '1px solid var(--border-light)'
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Nos Engagements */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 className="hero-medium" style={{ marginBottom: '16px' }}>Nos Engagements</h2>
            <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
              Des valeurs qui guident chacune de nos prestations
            </p>
          </div>

          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: window.innerWidth >= 768 ? 'repeat(3, 1fr)' : '1fr',
            gap: '32px'
          }}>
            {commitments.map((commitment, index) => (
              <div 
                key={index}
                style={{
                  padding: '32px 24px',
                  textAlign: 'center',
                  background: 'var(--bg-secondary)',
                  border: '1px solid var(--border-light)',
                  transition: 'transform 0.3s ease'
                }}
                className="hover-lift"
              >
                <div style={{ 
                  fontSize: '48px', 
                  marginBottom: '16px',
                  lineHeight: 1
                }}>
                  {commitment.icon}
                </div>
                <h3 className="heading-3" style={{ marginBottom: '12px', color: '#C9A961' }}>
                  {commitment.title}
                </h3>
                <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                  {commitment.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section 
        className="section-padding" 
        style={{ 
          background: 'linear-gradient(135deg, #F5F1E8 0%, #FDFCF9 100%)',
          textAlign: 'center'
        }}
      >
        <div className="container" style={{ maxWidth: '800px' }}>
          <div style={{ display: 'inline-flex', marginBottom: '24px' }}>
            <Heart size={40} color="#C9A961" />
          </div>
          <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
            Découvrez nos soins d'exception
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '40px' }}>
            Offrez-vous une expérience beauté naturelle et luxueuse
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link 
              to="/services" 
              className="btn-primary"
              style={{ background: '#C9A961', color: 'var(--bg-primary)', borderColor: '#C9A961' }}
            >
              Découvrir nos services
            </Link>
            <a 
              href="https://www.planity.com/nina-care-institut-91360-villemoisson-sur-orge" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Réserver en ligne
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ExcellenceNaturelle;
